import { CustomError } from 'src/helpers/error/custom-error';
import { IAuthService } from '../../auth/auth-service';
import { ILogService } from '../log/log-service';
import {
  buildEntityOptionsRequestPath,
} from './entity-options-endpoints';
import { EntityOptionRecord, IEntityOptionsService } from './entity-options-service';

export class EntityOptionsServiceImpl implements IEntityOptionsService {
  constructor(
    private logService: ILogService,
    private authService: IAuthService,
  ) {}

  async list(entity: string): Promise<EntityOptionRecord[]> {
    try {
      await this.logService.info('EntityOptionsServiceImpl.list -> start');

      const result = (await this.authService.http.get(
        buildEntityOptionsRequestPath(entity),
      )) as EntityOptionRecord[] | { items?: EntityOptionRecord[] };

      return Array.isArray(result) ? result : result?.items ?? [];
    } catch (error) {
      throw CustomError.handleError('EntityOptionsServiceImpl.list -> error', error);
    } finally {
      await this.logService.info('EntityOptionsServiceImpl.list -> end');
    }
  }
}
